var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-container1"}},[_c('base-header'),_c('div',{staticClass:"mt-4",attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('base-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }